import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config/contact';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const isConsulting = location.pathname.startsWith('/consulting');

  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-content">
          <h3 className="footer-title">Thomas Quantitative Strategies</h3>
          <p className="footer-description">
            {isConsulting 
              // ? "Early Career Consulting for High School, College Students, and Early Career Professionals."
              ? "Early career consulting for high school, college students, and early career professionals."
              : "Quantitative sports trading and research."}
          </p>
          <a href={`mailto:${isConsulting ? 'tqstrats@gmail.com' : CONTACT_EMAIL}`} className="footer-email">
            {isConsulting ? 'tqstrats@gmail.com' : CONTACT_EMAIL}
          </a>
          {!isConsulting && (
            <p className="footer-careers">
              Join Our Team: <Link to="/trading/careers" className="careers-link">Careers</Link>
            </p>
          )}
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} TQS, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
